/**
 * New Chat Button Component (Web)
 *
 * Single responsibility: Render new chat button for web sidebar
 */

import React from 'react';
import { NavbarIcon } from '../../shared/NavbarIcon';
import { brandColors } from '@/design-system/utils';

export interface NewChatButtonProps {
  onClick?: () => void;
}

export const NewChatButton: React.FC<NewChatButtonProps> = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      style={{ backgroundColor: brandColors.primary }}
      className='w-10 h-10 rounded-full flex items-center justify-center hover:opacity-90 transition-opacity'
      aria-label='New Chat'
    >
      <div style={{ filter: 'brightness(0) saturate(100%)' }}>
        <NavbarIcon iconName='plus' size={20} alt='New Chat' />
      </div>
    </button>
  );
};
